import React, { useEffect, useState } from 'react'

import {
  BannerContainer,
  IconWrapper,
  StyledBannerButton,
  StyledButtonRow
} from './Homepage.styles'
import { ClinTheme } from '../../ClinTheme'
import { ClinIcon } from '../../components/ClinIcon'
import { ClinIconPathName } from '../../components/ClinIcon/ClinIcon.paths'

const LYP_BANNER_URL =
  'https://www.clinigengroup.com/direct/en/love-your-pharmacist'

/** Set to true to show the Love Your Pharmacist homepage banner again. */
const SHOW_LYP_HOMEPAGE_BANNER = false

export const HomepageLypBanner: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) <= ClinTheme.breakpoints[2]
      )
    }

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  const handleLypBannerRedirect = () => {
    window.location.href = LYP_BANNER_URL
  }

  if (!SHOW_LYP_HOMEPAGE_BANNER) {
    return null
  }

  return (
    <StyledButtonRow style={{ marginTop: `${ClinTheme.space[4]}px` }}>
      <BannerContainer
        onClick={handleLypBannerRedirect}
        style={{ cursor: 'pointer' }}
      >
        <img
          src="/images/banner.png"
          alt="Love Your Pharmacist"
          style={{ display: 'block', width: '100%', height: 'auto' }}
        />
        {!isMobile && (
          <StyledBannerButton type="button" variant="primary">
            <IconWrapper>
              <ClinIcon
                iconName={ClinIconPathName.ArrowRight}
                iconFill={ClinTheme.colors.white}
              />
            </IconWrapper>
          </StyledBannerButton>
        )}
      </BannerContainer>
    </StyledButtonRow>
  )
}
